import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme'

import type { GetOffenseType } from '../../../types/GetOffense'

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};

    @media print {
        page-break-inside: avoid;
    }
`;


const TableCell = styled.td`
    border: 1px solid black;
    white-space: nowrap;
`;

const Label = styled.div`
    font-size: ${props => props.theme.font.size.small};
    font-weight: ${props => props.theme.font.weight.bold};
`;

interface OffensesProps {
    offenses: GetOffenseType[];
}

const Offenses: React.FC<OffensesProps> = ({ offenses }) => {

    return (
        <ThemeProvider theme={theme} >
            <Table cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr>
                        <td>
                            {
                                offenses.map((offense, index) => (
                                    <Table key={index} cellPadding="2" cellSpacing="0">
                                        <tbody>
                                            <tr>
                                                <TableCell>
                                                    <Label># Offenses</Label>
                                                    {offense && offense.offNo ? offense.offNo : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Offense</Label>
                                                    {offense && offense.offense ? offense.offense : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Description</Label>
                                                    {offense && offense.description ? offense.description : '\u00A0'}
                                                </TableCell>
                                            </tr>
                                        </tbody>
                                    </Table>
                                ))
                            }
                        </td>
                    </tr>
                </tbody>
            </Table>
        </ThemeProvider>
    );
}

export default Offenses;